export default __webpack_public_path__ + "img/favicons/apple-touch-icon-60x60.png";